export function Footer({ hideDisclaimer: _hideDisclaimer }: { hideDisclaimer?: boolean }) {
  return (
    <footer style={{ background: 'var(--school-primary)', color: '#fff' }} className="mt-auto">
      <div className="new-container" style={{ paddingTop: 56, paddingBottom: 40 }}>

        {/* ── 4-column grid ── */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">

          {/* Column 1 — Brand */}
          <div>
            <div style={{ fontSize: '1.25rem', fontWeight: 800, color: '#fff', letterSpacing: '-0.03em', lineHeight: 1, marginBottom: 10 }}>
              Unilytics
            </div>
            <p style={{ fontSize: 13, color: 'rgba(255,255,255,0.55)', lineHeight: 1.6, maxWidth: 220, margin: 0 }}>
              The standard for academic performance data.
            </p>
          </div>

          {/* Column 2 — Explore */}
          <div>
            <h4 style={{ fontSize: 10, fontWeight: 700, letterSpacing: '0.14em', textTransform: 'uppercase', color: 'rgba(255,255,255,0.35)', marginBottom: 16, margin: '0 0 16px' }}>
              Explore
            </h4>
            <nav style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <FooterLink href="/courses">Courses</FooterLink>
              <FooterLink href="/about">About</FooterLink>
              <FooterLink href="/faq">FAQ</FooterLink>
            </nav>
          </div>

          {/* Column 3 — Data */}
          <div>
            <h4 style={{ fontSize: 10, fontWeight: 700, letterSpacing: '0.14em', textTransform: 'uppercase', color: 'rgba(255,255,255,0.35)', margin: '0 0 16px' }}>
              Data
            </h4>
            <nav style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <FooterLink href="/faq">Data Sources</FooterLink>
              <FooterLink href="/faq">UDI Methodology</FooterLink>
              <FooterLink href="/about">Request Your School</FooterLink>
            </nav>
          </div>

          {/* Column 4 — Legal */}
          <div>
            <h4 style={{ fontSize: 10, fontWeight: 700, letterSpacing: '0.14em', textTransform: 'uppercase', color: 'rgba(255,255,255,0.35)', margin: '0 0 16px' }}>
              Legal
            </h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
              <p style={{ fontSize: 11, color: 'rgba(255,255,255,0.4)', margin: 0, lineHeight: 1.5 }}>
                © 2025 Unilytics
              </p>
              <p style={{ fontSize: 11, color: 'rgba(255,255,255,0.4)', margin: 0, lineHeight: 1.5 }}>
                Not affiliated with any university.
              </p>
              <p style={{ fontSize: 11, color: 'rgba(255,255,255,0.4)', margin: 0, lineHeight: 1.6 }}>
                Grade data sourced from public university records via FOIA requests.
              </p>
            </div>
          </div>
        </div>

        {/* ── Bottom bar ── */}
        <div
          style={{
            borderTop: '1px solid rgba(255,255,255,0.2)',
            marginTop: 40,
            paddingTop: 24,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 16,
            flexWrap: 'wrap',
          }}
        >
          <span style={{ fontSize: 11, color: 'rgba(255,255,255,0.35)' }}>
            Built to bring transparency to higher education.
          </span>
          <span style={{ fontSize: 11, color: 'rgba(255,255,255,0.35)' }}>
            Data is informational only. Not academic advice.
          </span>
        </div>
      </div>
    </footer>
  )
}

function FooterLink({ href, children }: { href: string; children: React.ReactNode }) {
  return (
    <a
      href={href}
      style={{
        display: 'block',
        fontSize: 13,
        color: 'rgba(255,255,255,0.6)',
        textDecoration: 'none',
        padding: '5px 0',
        transition: 'color 0.15s',
      }}
      onMouseEnter={e => { (e.currentTarget as HTMLAnchorElement).style.color = '#fff' }}
      onMouseLeave={e => { (e.currentTarget as HTMLAnchorElement).style.color = 'rgba(255,255,255,0.6)' }}
    >
      {children}
    </a>
  )
}
